import { OperationsResponse, Operation } from '../hooks/useOperations/types';

export const ALL_OPERATIONS = 'all-operations';
export const ALL_OPERATIONS_TITLE = 'All Operations';


// This function intends to replace the lodash uniqBy function. 
// The purpose is to eliminate those duplicated operations.
export const uniqBy = (arr: (string | number | Record<string, unknown>)[], predicate: string) => {
  const cb = typeof predicate === 'function' ? predicate : (o) => o[predicate];

  return [...arr.reduce((map, item) => {
    const key = (item === null || item === undefined) ?
      item : cb(item);
    if (!map.has(key)) {
      map.set(key, item);
    }

    return map;
  }, new Map()).values()];
};


export const allOperationsObject = {
  farms: [],
  operationId: ALL_OPERATIONS,
  operationName: ALL_OPERATIONS_TITLE,
  operationOwnerId: ''
};

export const mergeOperations = (operations: OperationsResponse): Operation[] => {
  const arr = [
    ...operations.operationLevelSharing,
    ...operations.farmLevelSharing,
    ...operations.fieldLevelSharing
  ];
  arr.sort((a, b) => a.operationName.localeCompare(b.operationName));

  const operationsArr = [
    allOperationsObject,
    ...operations.owned,
    ...arr
  ];

  return uniqBy(operationsArr, 'operationId');
};
